import { Controller } from "@hotwired/stimulus"

// Standalone opener for the cookies modal — usable from places outside the
// banner wrapper (e.g. footer link). Dispatches a window event that the main
// cookies controller listens for.
export default class extends Controller {
  open(event) {
    event?.preventDefault()
    window.dispatchEvent(new CustomEvent("pd:cookies:open"))
  }
}
